module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold.45ce9384.woff";